import { render, staticRenderFns } from "./Actividades.vue?vue&type=template&id=59e468d8&scoped=true"
import script from "./Actividades.vue?vue&type=script&lang=js"
export * from "./Actividades.vue?vue&type=script&lang=js"
import style0 from "./Actividades.vue?vue&type=style&index=0&id=59e468d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e468d8",
  null
  
)

export default component.exports